import { render, staticRenderFns } from "./expandable-categories.vue?vue&type=template&id=0f9bd05e&"
import script from "./expandable-categories.vue?vue&type=script&lang=js&"
export * from "./expandable-categories.vue?vue&type=script&lang=js&"
import style0 from "./expandable-categories.vue?vue&type=style&index=0&id=0f9bd05e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
